export function useMenu() {
  const { locale } = useI18n()
  const menuStore = useMenuStore()
  const { menu } = storeToRefs(menuStore)

  return useAsyncData(() => `menu-${locale.value}`, async () => {
    const wagtailClient = useWagtailClient(false, '', '', locale.value)
    const res = await wagtailClient.getMenuItems()
    const data = res?.data ?? { primary: [], secondary: [] }

    if (Array.isArray(data.primary)) {
      data.primary.forEach(e => (e.id += 100))
    }

    menu.value = data
    return data
  }, {
    server: true,
    watch: [locale],
  })
}
